import { useState, useCallback, createContext, useContext } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((msg, isError = false) => {
    setToast({ msg, isError });
    setTimeout(() => setToast(null), 3500);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast && (
        <div style={{
          position: 'fixed', top: 20, right: 20, zIndex: 9999,
          padding: '12px 20px', borderRadius: 8, maxWidth: 380,
          background: toast.isError ? '#1a0505' : '#051a0a',
          border: `1px solid ${toast.isError ? '#ef444433' : '#22c55e33'}`,
          color: toast.isError ? '#ef4444' : '#22c55e',
          fontSize: 12, fontFamily: '"JetBrains Mono", monospace', fontWeight: 600,
          animation: 'fadeIn 0.2s ease',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        }}>{toast.msg}</div>
      )}
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
